import { createRootRoute, Outlet } from '@tanstack/react-router'
import { Logo } from '@/components/ui/logo'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <main className={'font-montserrat flex h-dvh flex-col px-4 pt-5 pb-10'}>
      <header>
        <Logo width={60} height={30} />
      </header>
      <section className={'flex flex-1 flex-col overflow-hidden'}>
        <Outlet />
      </section>
      <TanStackRouterDevtools />
    </main>
  )
}
